import styled from 'styled-components';

export const H1 = styled.h1`
    display: block;
    font-size: 6rem;
    font-weight: normal;

    @media (max-width: 1024px) {
        font-size: 5rem;
    }

    @media (max-width: 768px) {
        font-size: 3.3rem;
    }

    @media (max-width: 500px) {
        font-size: 1.9rem;
    }
`;

export const H2 = styled.h2`
    display: block;
    font-size: 3rem;
    font-weight: normal;

    @media (max-width: 1024px) {
        font-size: 2.5rem;
    }

    @media (max-width: 768px) {
        font-size: 1.75rem;
    }

    @media (max-width: 500px) {
        font-size: 1.2rem;
    }
`;

export const H3 = styled.h3`
    display: block;
    font-size: 4rem;
    font-weight: normal;

    @media (max-width: 1024px) {
        font-size: 3.3rem;
    }

    @media (max-width: 768px) {
        font-size: 1.9rem;
    }

    @media (max-width: 500px) {
        font-size: 1.75rem;
    }
`;

export const H4 = styled.h2`
    display: block;
    font-size: 1.75em;
    font-weight: normal;

    @media (max-width: 1024px) {
        font-size: 1.5em;
    }

    @media (max-width: 768px) {
        font-size: 1.25em;
    }

    @media (max-width: 500px) {
        font-size: 1.1em;
    }
`;

export const P = styled.p`
    font-size: 1em;
`;
